import Swal from "sweetalert2"

export function popupBasicSuccess(text: string) {
    Swal.fire({
        title: "Success!",
        text: text,
        icon: "success",
        confirmButtonText: "Ok",
    })
}

export function popupError(title: string, text: string, html?: string) {
    Swal.fire({
        title: title,
        text: text,
        html: html,
        icon: "error",
        confirmButtonText: "Ok",
    })
}

export function popupBasicError(text: string) {
    popupError("Oops...", text)
}
